module.exports = __webpack_public_path__ + "media/klaseaDia2Barco3.0c5de512.mp4";